import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

import { resources } from './locales';

const I18N_DEBUG = process.env.I18N_DEBUG === 'true';

i18n

  // pass the i18n instance to react-i18next.
  .use(initReactI18next)

  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,

    lng: 'fr', // if you're using a language detector, do not define the lng option
    debug: (process.env.NODE_ENV === 'development' || I18N_DEBUG),

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
